<template>
  <div class="page-add">
    <div class="add-title">{{ !editId ? "新增申报" : "编辑申报" }}</div>
    <el-form
      class="form"
      size="small"
      label-position="right"
      label-width="120px"
      :rules="rules"
      :model="classForm"
      ref="classForm"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="培训名称：" prop="lectureName">
            <el-input
              style="width: 100%"
              v-model="classForm.lectureName"
              placeholder="请输入培训名称"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="培训时间：" prop="lectureTime">
            <el-date-picker
              style="width: 100%"
              v-model="classForm.lectureTime"
              type="datetimerange"
              range-separator="至"
              clearable
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              @change="timeChange"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item
            label="学时(小时)："
            prop="lectureHours"
            :rules="[
              {
                required: true,
                validator: limitInput,
                trigger: 'blur',
              },
            ]"
          >
            <el-input
              v-model="classForm.lectureHours"
              placeholder="请输入学时"
              oninput="value=value.replace(/[^0-9.]/g,'')"
              @change="inputHours"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="培训地点：" prop="lecturePlace">
            <el-input
              v-model="classForm.lecturePlace"
              placeholder="请输入讲座地点"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="培训单位：" prop="organizer">
            <el-input
              v-model="classForm.organizer"
              placeholder="请输入主办单位"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            class="scale"
            label="培训内容："
            prop="attachmentList"
          >
            <upload
              :limit="1"
              :path="'otherTrainDeclare/attachment'"
              v-model="classForm.attachmentList"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            label="现场照片："
            prop="sitePhotosList"
          >
            <div class="photos_style">
              <av-preview
                v-for="(item, i) in classForm.sitePhotosList"
                :key="'photo' + i"
                :src="item.url"
                type="image"
                @delete="deleteSitePhotos(i)"
              />
              <div class="upload_rect" v-if="classForm.sitePhotosList && classForm.sitePhotosList.length < 3">
                <upload
                  :limit="3"
                  :draggable="false"
                  type="image"
                  :path="'otherTrainDeclare/attachment'"
                  :size="20"
                  v-model="classForm.sitePhotosList"
                />
                <div class="upload_tip">
                  <p class="img_tip">只能上传jpg/jpeg/png格式文件，且不超过20Mb</p>
                </div>
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="m-t-l" label="参加学员：" required>
            <person-list ref="persons"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="form-handle form-text-center" label-width="0">
            <back-button :floatLeft="false"/>
            <el-button type="primary" @click="submit">提交</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { getLeaveDays } from "@/api/enrollment";
import { addOtherTrainDeclare, getIntervalCredit } from "@/api/topicLecture";
import { getSysParamByTypes } from "@/api/sysParam";
import Upload from "@/components/upload/index";
import rulesFactory from "@/utils/rules";
import { setItem } from "@/utils/storage.js";
import BackButton from "@/components/backButton/index";
import PersonList from "./personList";
import AvPreview from "@/components/av-preview/index";
import { pickerOptions } from "@/utils/timeFormat.js"

export default {
  name: "otherTrainDeclareAdd",
  components: { Upload, BackButton, PersonList, AvPreview },
  provide() {
    return {
      form: this,
    };
  },
  data() {
    return {
      pickerOptions: pickerOptions,
      editId: null, // 编辑
      rulesFactory,
      classForm: {
        lectureName: "",
        teacher: ""
      },
      rules: {
        lectureName: [rulesFactory.required("请输入培训名称"), rulesFactory.size('最多输入100个字', 0, 100)],
        lectureTime: [rulesFactory.required('请选择培训时间')],
        lecturePlace: [rulesFactory.required("请输入培训地点"), rulesFactory.size('最多输入100个字', 0, 100)],
        organizer: [
          rulesFactory.required('请输入培训单位'),
          rulesFactory.size('最多输入100个字', 0, 100),
        ],
        attachmentList: [rulesFactory.required('请上传培训内容')],
        sitePhotosList: [rulesFactory.required('请上传现场照片')],
      },
      classInfo: {},
      nowLectureHours: 0,
    };
  },
  created() {
    this.loadFlag = true; 
    this.addInfoDto();
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        this.dayTimeData = res.data["DATE_AM_PM"] || [];
      });
    },
    // 初始化当前数据
    addInfoDto() {
      this.classForm = {
        lectureName: "",
        lectureTime: null,
        lecturePlace: "",
        lectureHours: "",
        organizer: "",
        attachment: "",
        attachmentList: [],
        sitePhotos: "",
        sitePhotosList: [],
        userList: []
      };
    },
    deleteSitePhotos(index) {
      this.classForm.sitePhotosList.splice(index, 1);
    },

    timeChange(e) {
      if (e && e.length > 0) {
        let startDay = e[0];
        let endDay = e[1];
        this.classForm.lectureStartDate = startDay;
        this.classForm.lectureEndDate = endDay;
        let params = {
          lectureStartDate: this.classForm.lectureStartDate,
          lectureEndDate: this.classForm.lectureEndDate
        }
        getIntervalCredit(params).then((res) => {
          if (!res || res.code != 0) return;
          const time = res.data;
          this.classForm.lectureHours = time;
          this.nowLectureHours = time;
        });
      //   getLeaveDays({
      //     startDay, endDay,
      //     leaveType: 1,
      //     startDayType: 1,
      //     endDayType: 2,
      //   }).then((res) => {
      //   if (res.code !== 0) return;
      //   this.classForm.lectureHours = res.data * 8;
      // })
      }
    },
    //新增专题讲座申报
    submit() {
      this.$refs["classForm"].validate().then(() => {
        let params = Object.assign({}, this.classForm);
        let rawData = this.classForm;

        if (rawData.attachmentList && rawData.attachmentList.length > 0) {
          params["attachment"] = JSON.stringify(rawData.attachmentList);
        }
        if (rawData.sitePhotosList && rawData.sitePhotosList.length > 0) {
          params["sitePhotos"] = JSON.stringify(rawData.sitePhotosList);
        }
        if (this.$refs["persons"].persons.length === 0) {
          this.$message({
            message: "请选择参加学员",
            type: "error",
          });
          return;
        }
        delete params.lectureTime;
        params.userList = this.$refs["persons"].persons.map((ele) => ({
          userMobile: ele.userMobile,
          userName: ele.userName,
          userId: ele.uuid,
          unitPosition: ele.unitPosition,
          deptName: ele.deptName,
          deptId: ele.deptId
        }));
        console.log(params);
        addOtherTrainDeclare(params).then((res) => {
          if (!res || res.code != 0) return;
          setItem(this.REFRESH_FLAG, true);
          this.$message({
            message: "操作成功！",
            type: "success",
          });
          this.$router.back();
        });
      })
      .catch(() => {});
    },
    limitInput(rule, value, callback) {
      if (value.length === 0) {
        callback(new Error("请输入学时"));
      } else if (parseFloat(value) == 0) {
        callback(new Error("学时数不能为0"));
      } else if (parseFloat(value) > this.nowLectureHours) {
        callback(new Error("学时要求：45分钟1学时，不足45分钟按比例换算，1天不超过8学时"));
      } else {
        callback();
      }
    },
    inputHours(value) {
      console.log(value);
      if (Number(value) < 0) {
        return this.classForm.lectureHours = 0;
      }
      if (value != "") {
        if (value.indexOf(".") == 0) {
          this.classForm.lectureHours = '0.';
        } else if (value.indexOf(".") > 0) {
          this.classForm.lectureHours = value.slice(0, value.indexOf(".") + 3);
        } else {
          this.classForm.lectureHours = value;
        }
      } else this.classForm.lectureHours = ""
    },
  },
};
</script>

<style lang="scss" scoped>
#video-cover {
  margin-right: 16px;
}
 .devide_line {
  line-height: 32px;
  margin-left: 12px;
 }
.unit_style {
  display: flex;
  flex-direction: row;
}
$textColor: #51627d;
/deep/ .period_form .el-form-item__content {
  margin-left: 16px !important;
}
/deep/ .el-input-group__prepend {
  background-color: #909399;
  border: 0px solid #dcdfe6;
  padding: 0 0px;
}
/deep/ .scale .el-input {
  width: 50%;
  color: $textColor;
  font-size: 12px;
}
.form-select {
  width: 100%;
}
/deep/ .el-form-item__content {
  .el-select.select {
    width: 100% !important;
  }
}
.upload_tip {
  width: 280px;
  text-align: center;
}
.upload_tip p {
  font-size: 14px;
  margin: 0;
  // line-height: 30px;
  color: #51627d;
}
.upload_tip p.img_tip {
  font-size: 12px;
  text-align: left;
  color: #606266;
}
/deep/ .el-range-editor--small.el-input__inner {
  width: 100%;
}
.form-text-center {
  text-align: center !important;
}
.input {
  width: 150px !important;
}
.photos_style {
  display: flex;
}
</style>
